import styled, { css } from 'styled-components';
import { Link } from 'react-router';

const commonHeadingStyles = css`
  color: ${({ theme }) => theme.palette.common.black};
  font-family: ${({ theme }) => theme.fontFamily};
  font-optical-sizing: auto;
  font-style: normal;
  font-weight: 700;
  margin: 0 0 16px;
  line-height: 150%;
`;

export const StyledHeading1 = styled.h1`
  ${commonHeadingStyles};
  font-size: ${({ theme }) => theme.utils.pxToRem(32)};
`;

export const StyledHeading2 = styled.h2<{ $isCentered?: boolean }>`
  ${commonHeadingStyles};
  font-size: ${({ theme }) => theme.utils.pxToRem(28)};
  text-align: ${({ $isCentered }) => ($isCentered ? 'center' : 'left')};
`;

export const StyledHeading3 = styled.h3`
  ${commonHeadingStyles};
  font-size: ${({ theme }) => theme.utils.pxToRem(24)};
`;

export const StyledHeading4 = styled.h4`
  ${commonHeadingStyles};
  font-size: ${({ theme }) => theme.utils.pxToRem(20)};
`;

export const StyledHeading5 = styled.h4`
  ${commonHeadingStyles};
  font-size: ${({ theme }) => theme.utils.pxToRem(18)};
  font-weight: 500;
`;

const paragraphStyles = css`
  color: ${({ theme }) => theme.palette.common.black};
  font-family: ${({ theme }) => theme.fontFamily};
  font-optical-sizing: auto;
  font-size: ${({ theme }) => theme.utils.pxToRem(16)};
  font-style: normal;
  font-weight: 400;
  line-height: ${({ theme }) => theme.utils.pxToRem(24)};
  margin: 0;
  text-align: justify;

  & + * {
    margin-top: 16px;
  }

  svg {
    margin-right: 8px;
  }
`;

export const StyledParagraph = styled.p`
  ${paragraphStyles};

  a {
    color: inherit;
    text-decoration: none;
    transition: color 300ms ease-in-out;

    &:hover,
    &.active {
      color: ${({ theme }) => theme.palette.primary.bold};
    }
  }

  strong {
    font-weight: bold;
  }
`;

export const StyledLink = styled(Link)`
  ${paragraphStyles};
  text-decoration: none;
  transition: color 300ms ease-in-out;
  margin-bottom: 0;
  line-height: unset;

  &:hover {
    color: ${({ theme }) => theme.palette.primary.bold};
  }
`;

export const StyledOrderedList = styled.ol`
  ${paragraphStyles};
  list-style-type: decimal;
  padding-left: 1em;
`;

export const StyledUnorderedList = styled.ul`
  ${paragraphStyles};
  list-style-type: disc;
  padding-left: 1em;
`;
